import { createSelector } from 'reselect'

import { getEntities } from './rootSelectors'
import { filterId } from '../opoint/search/index'
import type { Filter } from '../opoint/flow'

export const getFilterDetail = (filter: Filter) =>
  createSelector(getEntities, (entitiesState) => entitiesState.filters[filterId(filter)])
